export default __webpack_public_path__ + "static/media/githubCap.94fc0a70.PNG";